export class WFEBankBalanceResultDto {
    bankBalance: number;
}
